'use strict';

var d3 = require('d3');
var ReviewInputDataChart = function ReviewInputDataChart(AbstractChart, SeasonalityConstants, chartMultiBrush, chartGroups, chartXAxis, chartYAxis, chartStripes, chartSimpleBars, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('rangechange');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var brush = chartMultiBrush();
    var groups = chartGroups('d1', formatters.tooltipFormatter, true);
    var stripes = chartStripes('data');
    var bars = chartSimpleBars('all-week');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).withoutHorizontalLines();
    this.render = function (data, range) {
      range = range || [0, data.length];
      this.initChart(data, range, chartParams);
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.callForPreDataGroup([brush.withDomainRange(this.visibleXRange)], this.scales);
      this.callForDataGroup([yAxisLeft, groups, bars, stripes, xAxis], this.scales);
      if (brush.isSelectionInitialized()) {
        brush.updateBrush();
      }
    };
    this.getSelection = function () {
      return brush.getSelection();
    };
    this.domainChange = function (range) {
      this.render(this.data, range);
    };
    this.setInitialSelection = function (range) {
      brush.setSelection(range);
    };
    this.withMetric = function (metric) {
      yAxisLeft.label(metric.label);
      return this;
    };
    this.withDisplayMode = function (displayMode) {
      var displayByDate = displayMode === SeasonalityConstants.DISPLAY_BY_DATE_MODE;
      xAxis.withTextRotation(displayByDate ? chartConstants.AXIS.SKEW.DEG_30 : undefined);
      return this;
    };
    brush.on('brushchange', function (ranges) {
      this.brushChangeAction(ranges, groups);
      dispatch.rangechange(ranges);
    }.bind(this));
    groups.on('groupclick', function (d, i) {
      brush.setSelection([i, i + 1]);
    });
    container.on('$destroy', function () {
      groups.on('groupclick', null);
      brush.on('brushchange', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ReviewInputDataChart.$inject = ['AbstractChart', 'SeasonalityConstants', 'ChartElementsMultiBrush', 'ChartElementsGroup', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsStripes', 'ChartElementsSimpleBars', 'ChartElementsConstants'];
module.exports = ReviewInputDataChart;